module.exports = __webpack_public_path__ + "img/refresh-square-2.ff802812.svg";